
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/transferlist",
      function () {
        return require("private-next-pages/bundesliga/transferlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/transferlist"])
      });
    }
  